"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _TruncatedTextContainer = _interopRequireDefault(require("./TruncatedTextContainer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _TruncatedTextContainer["default"];
exports["default"] = _default;